import i18n from "@/i18n/config";

/** Backend-supported locale codes for Accept-Language */
const SUPPORTED = new Set(["en", "de", "sr"]);

/**
 * Current UI language for API/GraphQL `Accept-Language` (en, de, sr).
 * Keeps i18n as the single source of truth (in sync with language store).
 */
export function getAcceptLanguageHeader(): string {
  const raw = i18n.language ?? "de";
  const base = raw.split("-")[0]?.toLowerCase() ?? "de";
  return SUPPORTED.has(base) ? base : "de";
}
